import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAppDispatch } from '../../../hooks/store-hooks'
import { setPasswordRecoveryStepState } from '../../../../application/states/auth'

export const PasswordRecoveryIndex = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const code = searchParams.get('code') // HashUrl do link do email
  const token = searchParams.get('token') // Mantido para compatibilidade com links antigos

  useEffect(() => {
    if (code || token) {
      // Se houver código ou token, pular direto para passo 3 (create-new-password)
      dispatch(setPasswordRecoveryStepState({ step: 2 }))
      if (code) {
        navigate(`/auth/password-recovery/create-new-password?code=${encodeURIComponent(code)}`, { replace: true })
      } else if (token) {
        // Compatibilidade com links antigos que usam token
        navigate(`/auth/password-recovery/create-new-password?code=${encodeURIComponent(token)}`, { replace: true })
      }
    } else {
      // Se não houver código nem token, ir para passo 1
      navigate('/auth/password-recovery/request-new-password', { replace: true })
    }
  }, [code, token, navigate, dispatch])

  return null
}

